import { Form, Formik } from "formik";
import { Container, Modal } from "react-bootstrap";

import PrimaryButton from "../../../util/Btns/PrimaryButton";
import FormikControl from "../../../util/formcomponents/FormikControl";

import styles from "./FingerprintModal.module.scss";
import Close from "../../../Assets/close.svg";

const FingerprintModal = ({ addFingerprint, showAddFingerprint }) => {
  const initialValues = {
    fingerprint: "",
    type: "",
  };
  const typeOptions = [
    { key: "production", value: "production" },
    { key: "debug", value: "debug" },
  ];
  const onSubmit = (values) => {
  };
  return (
    <div>
      <Container>
        <Modal
          show={addFingerprint}
          onHide={() => showAddFingerprint(false)}
          centered
          contentClassName={styles.content}
          dialogClassName={styles.dialog}
        >
          <Modal.Body>
            <div className={styles.body}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                }}
                className=""
              >
                <h4 className="">Add Fingerprint</h4>
                <img
                  onClick={() => showAddFingerprint(false)}
                  src={Close}
                  height="14"
                  width="14"
                  alt="cross"
                  className="cursor-pointer"
                />
              </div>
              <Formik
                initialValues={initialValues}
                // validationSchema={validationSchema}
                onSubmit={onSubmit}
              >
                {(formik) => {
                  return (
                    <Form>
                      <div className="">
                        <FormikControl
                          control="input"
                          required={false}
                          type="text"
                          label="SHA Certificate Fingerprint"
                          name="fingerprint"
                        />
                        <FormikControl
                          control="radio"
                          required={false}
                          options={typeOptions}
                          label="Select type"
                          name="type"
                        />
                      </div>
                      {/* Button================================================================ */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          marginTop: "1em",
                        }}
                        className=""
                      >
                        <PrimaryButton
                          onClick={() => showAddFingerprint(false)}
                        >
                          Add Fingerprint
                        </PrimaryButton>
                      </div>
                      {/* Button================================================================== */}
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </Modal.Body>
        </Modal>
      </Container>
    </div>
  );
};

export default FingerprintModal;
